import React, { useState, useEffect } from 'react'
import { Panel, Row, Message } from 'rsuite'
import { Controller, useForm } from 'react-hook-form'
import { doneLoading, startLoading } from '../../../utils/loading'
import ButtonPanel from '../../ButtonPanel'
import { saveTargetDep6Criteria, updateTargetDep6Criteria } from '../../../redux/actions/tagetDep6'
import { useParams } from 'react-router'
import scrollToComponent from 'react-scroll-to-component'
import CKEditorFrom from '../../../components/forms/input/CKEditorFrom'

export default function TagetDep6CriterionWidget({
  schema: _schema,
  showCommandButton,
  type,
  ...props
}) {
  const [section, setSection] = useState()
  const [isEdit, setIsEdit] = useState(_schema?.value ? false : true)
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const { register, handleSubmit, errors, control, setValue, clearErrors } = useForm()
  const [schema, setSchema] = useState(_schema)
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    // console.log(schema)
    setSchema(_schema)
  }, [_schema])

  const handleUpdateSave = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      let response
      if (request.id) {
        console.log('call update.')
        response = await updateTargetDep6Criteria(projectId, type, request)
      } else {
        console.log('call save.')
        response = await saveTargetDep6Criteria(projectId, type, request)
      }

      if (response) {
        setSchema(response.targetCriteria)
        setIsEdit(false)
      } else {
        setIsError(true)
      }
    } catch (e) {
      console.log('e', e)
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const onSubmit = (data) => {
    console.log('data', data)

    const request = {
      id: data.selectedId,
      projectVersionId: projectId,
      targetCriteria: data.targetCriteria,
    }
    // console.log('request', JSON.stringify(request))
    handleUpdateSave(request)
  }
  return (
    <div>
      {schema && (
        <Panel
          style={{ marginBottom: 10 }}
          bordered={showCommandButton}
          header={showCommandButton && schema.label}
          collapsible
          defaultExpanded
          ref={(section) => {
            setSection(section)
          }}
          bodyFill={!showCommandButton}
        >
          {isEdit && !schema.disabled && showCommandButton ? (
            <div>
              {schema.alert && (
                <Message
                  style={{ marginBottom: 10 }}
                  showIcon
                  type="warning"
                  description={schema.alert}
                />
              )}
              <CKEditorFrom
                schema={schema}
                toolbar={[]}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
              />
            </div>
          ) : (
            <div>
              <p>
                <b>{schema.label} : </b>
              </p>
              {schema.value ? (
                <div
                  style={{ marginLeft: 20 }}
                  dangerouslySetInnerHTML={{ __html: schema.value }}
                />
              ) : (
                <p style={{ marginLeft: 20 }}>{`ไม่ได้ระบุ${schema.label}`}</p>
              )}
            </div>
          )}

          {!schema.disabled && showCommandButton && (
            <>
              <hr />
              <ButtonPanel
                isDisabled={isLoading}
                isEdit={isEdit}
                isError={isError}
                buttonText={schema.label || 'เกณฑ์การคัดเลือก'}
                onSave={handleSubmit(onSubmit)}
                onCancel={() => {
                  setIsError(false)
                  setIsEdit(!isEdit)
                  scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
                }}
                onEdit={() => {
                  setIsError(false)
                  setIsEdit(!isEdit)
                  scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
                }}
              />
            </>
          )}
        </Panel>
      )}
    </div>
  )
}
